package one.healthium.db

import kotlin.Long
import kotlin.String

public data class SavedContentEntity(
  public val id: String,
  public val contentId: String,
  public val contentType: String,
  public val title: String?,
  public val description: String?,
  public val thumbUrl: String?,
  public val saveType: String,
  public val savedAt: Long,
)
